import React, { useState, useEffect } from "react";
import { Modal, Input, Table, Button } from "antd";
import { getRequest, postRequest } from "../../services";
import { Spin } from 'antd';
import NameAvatar from "../Common/Avatar";
import { message } from 'antd';
import { LeftOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";

const GradeTableMcQs = (props) => {
  const { filteredExamsId, setExamPublish, setPublishStatus } = props;
  const [currentPage, setCurrentPage] = useState(0); // Current question set
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null); // Active row for modal
  const [remark, setRemark] = useState(""); // Remark input
  const [loading, setLoading] = useState(false);
  const [myMcQs, setMyMcQs] = useState([]);

  const handlePagination = (direction) => {
    setCurrentPage((prev) =>
      direction === "next" ? prev + 1 : prev - 1
    );
  };
  const showModal = (index) => {
    setActiveRowIndex(index);
    setRemark(myMcQs[index]?.remark || "");
    setIsModalVisible(true);
  };

  const handleOk = async () => {

    const payload = {
      userId: myMcQs[activeRowIndex].student.studentId,
      subjectId: filteredExamsId[currentPage]?.subjectDetails?.subjectId || "",
      examId: filteredExamsId[currentPage]?.id || "",
      remarks: remark || "",
      mcqsAnswers: myMcQs[activeRowIndex].questions.map((question) => ({
        questionId: question.questionId || "",
        marks: question.marks || 0,
      })),
    };
    try {
      const response = await postRequest(`/api/Grades/evaluate-mcqs`, payload);
      if (response.status === 200 || response.statusText) {
        message.success(response.data.message || "Update successfully");
        fetchData();
      } else {
        message.error("Failed to save lesson");
      }
    } catch (error) {
      console.error("Error:", error.message);
      message.error("An error occurred while saving the lesson");

    }
    setIsModalVisible(false);
    setActiveRowIndex(null);
  };

  const handleCancel = () => {

    setIsModalVisible(false);
    setActiveRowIndex(null);
  };

  const fetchData = async () => {
    if (!filteredExamsId || !filteredExamsId[currentPage]?.id) {
      console.warn("filteredExamsId is null or undefined, or currentPage is invalid.");
      return;
    }
    setLoading(true);
    try {
      const response = await getRequest(
        `/api/Grades/mcqs-submission-details?examId=${filteredExamsId[currentPage].id}`
      );
      const status = await getRequest(`/api/Grades/ResultStatus?examId=${filteredExamsId[currentPage].id}`);
      setPublishStatus(status.data);

      // Combine submitted and absent students
      const { submittedStudents = [], absentStudents = [] } = response.data;

      // Map absent students to the same structure as submitted
      const absentMapped = absentStudents.map(absent => ({
        student: {
          studentId: absent.studentId,
          name: absent.studentName,
          profilePicture: absent.profilePicture,
          marksAlloted: {
            alloted: absent.alloted,
            remarks: absent.remarks,
          },
        },
        questions: [], // No questions for absent students
        isAbsent: true,
      }));

      // Map submitted students to add isAbsent: false
      const submittedMapped = submittedStudents.map(sub => ({
        ...sub,
        isAbsent: false,
      }));

      const combined = [...submittedMapped, ...absentMapped];

      setExamPublish({
        Exam: filteredExamsId[currentPage],
        Question: combined,
      });
      setMyMcQs(combined);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [currentPage, filteredExamsId[currentPage]?.id]);
  // console.log("filteredExamsId",filteredExamsId[currentPage])
  const getColumns = () => {
    const baseColumns = [
      {
        title: "Student Name",
        dataIndex: "name",
        key: "name",
        fixed: 'left',
        render: (_, record) => (
          <div className="d-flex align-items-center gap-2">
            {record.student.profilePicture ? (
              <img src={record.student.profilePicture} alt="user" style={{ width: '30px', height: '30px', borderRadius: '50%' }} />
            ) : (
              <div style={{
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                background: '#ccc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#fff',
              }}>
                {record.student.name ? record.student.name.charAt(0).toUpperCase() : '?'}
              </div>
            )}
            <span>{record.student.name}</span>
          </div>
        ),
      },
      {
        title: "Score",
        dataIndex: "score",
        key: "score",
        render: (_, record) => record.isAbsent ? 0 : `${Math.round(
          (record.questions.reduce((acc, q) => acc + q.marks, 0) /
          record.questions.reduce((acc, q) => acc + q.totalMarks, 0)) * 100
        )}%`,
      },
      {
        title: "Remarks",
        dataIndex: "remarks",
        key: "remarks",
        render: (_, record, index) => {
          if (record.isAbsent) {
            return "-";
          }
          return !record.student.marksAlloted.alloted ? (
            <Button type="primary" size="small" onClick={() => showModal(index)}>
              Add Remark
            </Button>
          ) : (
            record.student.marksAlloted.remarks
          );
        },
      },
    ];

    // Additional columns for larger screens
    const extraColumns = [
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        render: (_, record) => record.isAbsent ? "A" : "PP",
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
        render: () => "Exam",
      },
      {
        title: "Submitted",
        dataIndex: "submitted",
        key: "submitted",
        render: (_, record) => record.isAbsent ? "No" : "Yes",
      },
    ];

    // Check if screen width is less than 768px (mobile)
    const isMobile = window.innerWidth < 768;
    return isMobile ? baseColumns : [...baseColumns.slice(0, 1), ...extraColumns, ...baseColumns.slice(1)];
  };

  const [columns, setColumns] = useState(getColumns());

  // Update columns on window resize
  useEffect(() => {
    const handleResize = () => {
      setColumns(getColumns());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const expandedRowRender = (record) => (
    <div className="bg-gray-50 rounded p-6">
      {record.questions.map((question, qIndex) => (
        <div key={qIndex} className="mb-4 border-b pb-4 border-gray-200">
          <p>
            <strong>{qIndex + 1}:</strong> {question.questionText}
          </p>
          <ul className="list-disc ml-5">
            {Object.entries(question.options).map(([key, value]) => (
              <li
                key={key}
                style={{
                  color: question.correctOption.toLowerCase() === key.toLowerCase() ? "green" : "inherit",
                }}
              >
                <strong>{key.toUpperCase()}:</strong> {value}
              </li>
            ))}
          </ul>
          <p>
            <strong>Selected Option:</strong>{" "}
            <span
              className={
                question.selectedOption === question.correctOption
                  ? "text-green-600"
                  : "text-red-600"
              }
            >
              {question.selectedOption}{" "}
              {question.selectedOption === question.correctOption ? (
                <span>✔️</span>
              ) : (
                <span>❌</span>
              )}
            </span>
          </p>
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={myMcQs}
          expandable={{
            expandedRowRender,
            rowExpandable: (record) => !record.isAbsent,
            expandIcon: ({ expanded, onExpand, record }) => (
              <DownOutlined
                style={{ 
                  transform: expanded ? 'rotate(180deg)' : 'none',
                  transition: '0.3s',
                  cursor: record.isAbsent ? 'not-allowed' : 'pointer',
                  color: record.isAbsent ? '#ccc' : undefined,
                  pointerEvents: record.isAbsent ? 'none' : 'auto',
                }}
                onClick={e => {
                  if (!record.isAbsent) onExpand(record, e);
                }}
              />
            )
          }}
          pagination={false}
          rowKey={(record) => record.student.studentId}
          bordered
          scroll={{ x: 'max-content' }}
          className="responsive-table"
          size="small"
        />
        {filteredExamsId.length > 0 && (
          <div className="flex justify-center mt-4 pb-4 gap-3">
            <Button
              onClick={() => handlePagination("previous")}
              disabled={currentPage < 1}
              icon={<LeftOutlined />}
            />
            <span className="bg-[#241763] text-white px-3 py-1 mx-1 border rounded d-flex align-items-center">
              {`${currentPage + 1}/${filteredExamsId.length}`}
            </span>
            <Button
              onClick={() => handlePagination("next")}
              disabled={currentPage >= filteredExamsId.length - 1}
              icon={<RightOutlined />}
            />
          </div>
        )}
      </Spin>
      <Modal
        title="Add Remark"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="row p-3">
          <div className="col-md-12">
            <Input.TextArea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Enter your remark here"
              rows={4}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GradeTableMcQs;
